// Existing live Basic product-drawer behavior. Shared guard prevents duplicate listeners on Basic pages.
(() => {
    if (window.GiestoSplashProducts) return;
    window.GiestoSplashProducts = true;

    const focusTargets = new WeakMap();
    const scrollStyles = new WeakMap();

    const restoreDialogState = (dialog, restoreFocus = true) => {
      if (!focusTargets.has(dialog)) return;
      const opener = focusTargets.get(dialog);
      document.body.style.overflowY = scrollStyles.get(dialog) || '';
      scrollStyles.delete(dialog);
      focusTargets.delete(dialog);
      opener.setAttribute('aria-expanded', 'false');
      if (restoreFocus && document.contains(opener)) opener.focus({ preventScroll: true });
    };

    const closeDialog = (dialog) => {
      if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
      dialog.close();
      // The native close event is queued. Finish this opening's cleanup now,
      // before another click can reopen the drawer and replace its saved state.
      restoreDialogState(dialog);
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const opener = target.closest('[data-giesto-splash-open]');
      if (opener instanceof HTMLButtonElement) {
        const dialogId = opener.getAttribute('aria-controls');
        const dialog = dialogId ? document.getElementById(dialogId) : null;
        if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

        event.preventDefault();
        // Also handle a native close followed by reopening before its event runs.
        restoreDialogState(dialog, false);
        const money = new Intl.NumberFormat(dialog.dataset.locale === 'tr' ? 'tr-TR' : 'en-GB', {
          style: 'currency', currency: dialog.dataset.currency || 'TRY',
        });
        dialog.querySelectorAll('[data-splash-money]').forEach(price => {
          const formatted = money.format(Number(price.dataset.splashMoney) / 100);
          if (price.textContent !== formatted) price.textContent = formatted;
        });
        focusTargets.set(dialog, opener);
        opener.setAttribute('aria-expanded', 'true');
        scrollStyles.set(dialog, document.body.style.overflowY);
        document.body.style.overflowY = 'hidden';
        opener.focus({ preventScroll: true });
        dialog.showModal();
        dialog.querySelector('[data-giesto-splash-close]')?.focus({ preventScroll: true });
        return;
      }

      const closeButton = target.closest('[data-giesto-splash-close]');
      if (closeButton instanceof HTMLButtonElement) {
        closeDialog(closeButton.closest('[data-giesto-splash-dialog]'));
        return;
      }

      if (target instanceof HTMLDialogElement && target.matches('[data-giesto-splash-dialog]')) {
        closeDialog(target);
      }
    });

    // Keep the product drawer behind its size picker until adding succeeds.
    document.addEventListener('shopify:cart:lines-update', event => {
      if (event.action !== 'add' || !(event.promise instanceof Promise)) return;
      const source = event.target instanceof Element ? event.target.closest('[data-giesto-splash-dialog]') : null;
      const dialog = source || (document.querySelector('#GiestoStoreSizePicker[data-splash][open]')
        ? document.querySelector('[data-giesto-splash-dialog][open]') : null);
      if (!dialog) return;
      event.promise.then(result => {
        if (!result?.detail?.didError) closeDialog(dialog);
      }).catch(() => {});
    });

    document.addEventListener('cancel', (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-giesto-splash-dialog]')) return;
      event.preventDefault();
      closeDialog(dialog);
    }, true);

    document.addEventListener('close', (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-giesto-splash-dialog]')) return;
      // Ignore an old close event delivered after the same drawer reopened.
      if (!dialog.open) restoreDialogState(dialog);
    }, true);
  })();
